<template>
  <div>
    <v-container>
      <div class="md-12 lg-12 xs-12 sm-12">
        <p class="primary--text display-1 font-weight-bold pt-8">Biblioteca</p>
        <v-card class="overflow-hidden" color="transparent" flat>
          <div class="d-flex flex-column flex-md-row">
            <p
              class="body-1 font-weight-medium text-left pt-0 pt-4 primary--text"
              style="max-width:700px"
            >
              La biblioteca de CostaPez cuenta con información de peces e
              invertebrados característicos de nuestras costas. Aquí podrás
              conocer información de su biología, ecología, estado de
              conservación y recomendaciones para su captura, entre otros datos
              relevantes.
            </p>
            <v-spacer></v-spacer>
            <div class="flex ml-6" style="min-width:300px">
              <v-text-field
                class="align-end"
                v-model="searchText"
                @input="onChangeSearchText"
                outlined
                clearable
                hide-details
                rounded
                prepend-inner-icon="search"
                placeholder="Buscar"
              ></v-text-field>
            </div>
          </div>
        </v-card>
      </div>
      <v-divider class="mt-6 primary"></v-divider>
    </v-container>

    <v-container class="pa-0">
      <v-slide-group show-arrows v-if="loading">
        <template v-slot:prev>
          <v-btn fab small color="#c0e2e6">
            <v-icon color="primary">mdi-chevron-left</v-icon>
          </v-btn>
        </template>
        <template v-slot:next>
          <v-btn fab small color="#c0e2e6">
            <v-icon color="primary">mdi-chevron-right</v-icon>
          </v-btn>
        </template>
        <v-slide-item
          v-for="item of [1, 2, 3, 4, 5, 6, 7, 8]"
          :key="item"
          class="py-10"
        >
          <v-skeleton-loader
            class="ma-4"
            type="card"
            width="200"
            height="215"
          ></v-skeleton-loader>
        </v-slide-item>
      </v-slide-group>
      <v-slide-group show-arrows v-else>
        <template v-slot:prev>
          <v-btn fab small color="#c0e2e6">
            <v-icon color="primary">mdi-chevron-left</v-icon>
          </v-btn>
        </template>
        <template v-slot:next>
          <v-btn fab small color="#c0e2e6">
            <v-icon color="primary">mdi-chevron-right</v-icon>
          </v-btn>
        </template>
        <v-slide-item
          v-for="organism of organismList"
          :key="organism.id"
          class="py-10"
        >
          <LibraryItemLanding :item="organism"></LibraryItemLanding>
        </v-slide-item>
      </v-slide-group>
    </v-container>
  </div>
</template>

<script>
import LibraryItemLanding from "./LibraryItemLanding";
export default {
  components: { LibraryItemLanding },
  data: () => ({
    searchText: "",
    organismList: [],
    loading: true,
    limit: 15,
    jureles: require("@/assets/landing/jureles.jpg"),
    _timerId: null,
  }),
  methods: {
    async getData() {
      try {
        this.loading = true;
        let { data: organismList } = await this.$http.get("organism", {
          params: {
            where: {
              searchText: {
                contains: (this.searchText || "").toLowerCase(),
              },
              sp_card: true,
            },
            sort: "mostSearched DESC",
            limit: this.limit,
          },
        });
        this.organismList.push(...organismList);
        this.loading = false;
      } catch (err) {
        //console.log(err);
      }
    },
    async onChangeSearchText() {
      clearTimeout(this._timerId);
      this.loading = true;
      this._timerId = setTimeout(() => {
        this.organismList = [];
        this.page = 1;
        this.getData();
      }, 800);
    },
  },
  computed: {
    practitionerLogged() {
      return this.$store.getters["authPractitioner/getPractitioner"];
    },
  },
  mounted: function() {
    this.getData();
  },
};
</script>

<style></style>
